<template>
  <div class="excel-up">
      <input v-if="" id="excel-upload-input" ref="excel-upload-input" type="file" accept=".xlsx, .xls" @change="handleClick">
      <!-- <el-button v-show="!loading" style="margin-left:16px;" size="mini" type="primary" @click="handleUpload">
           <span>导入Excel</span>
      </el-button> -->
      <el-button v-show="loading"  size="mini" type="primary">
            <span>导入中</span>
            <span class="el-icon-loading"></span>
      </el-button>
  </div>

</template>

<script>
// import XLSX from 'xlsx';
// import { excelIn1,excelIn2,excelIn3,excelIn4,excelIn5,excelIn6,excelIn7,excelIn8,ExcelErrors } from '@/api/pressAsk';
// import { tb2Edit,tb2Predata } from '@/api/edits';
// import { deleteAll6 } from '@/api/rowsDelete';

export default {
  // props: {
  //     seccessFun
  // },
    //   props:['tbtp','orgid'],
  data() {
    return {
      loading: false,
      numData:{

      },
      excelData: {
        header: null,
        results: null,
      }
    }
  },
  methods: {

    handleUpload() {
        document.getElementById('excel-upload-input').click()
    },
    // errorHandler:function(batchNum,loading){
    //     var vm = this;

    //     getErrorImportLog({batchNum:batchNum}).then(response => {
    //         var errorDatas = [];
    //         for(var i in response.payload.exportLogs){
    //              if(response.payload.exportLogs[i].errMsg){
    //                   errorDatas.push(response.payload.exportLogs[i]);
    //              }
    //         }
    //         var successSure = true;
    //         for(var i in errorDatas){
    //              if(errorDatas[i].errMsg){
    //                   successSure = false;
    //                   break;
    //              }
    //         }

    //         setTimeout(() => {
    //                 loading.close();
    //                 if(successSure){
    //                     vm.$alert('导入成功！', '提示', {
    //                         confirmButtonText: '确定',
    //                         type: 'success',
    //                         callback: function(action){
    //                             vm.$emit('t-frash');
    //                         }
    //                     });
    //                 }else {
    //                     vm.$message.error('导入失败！');
    //                     vm.$emit('excel-errors',errorDatas);
    //                     vm.$emit('t-frash');

    //                 }
    //         }, 600);

    //     }).catch(error => {
    //        loading.close();
    //     })
    // },

    // specialUpex:function(i,data,errorDatas,loading){
    //     var vm = this;
    //     var postArr = [];
    //     var len = 100;


    //     if( data.length > i*len ){
    //         var post = {};
    //         post.importIndustrialSpaceList = data.splice(i*len,len);
    //         importIndustrialSpaces(post).then(response => {
    //             console.log('importIndustrialSpaces',response);
    //             getErrorImportLog({batchNum:response.batchNum}).then(response => {
    //                 console.log('getErrorImportLog',response);
        
    //                 for(var t in response.importLogList){
    //                         if(response.importLogList[t].message){
    //                             errorDatas.push(response.importLogList[t]);
    //                         }
    //                 };
                    
    //                 i++;
    //                 return vm.specialUpex(i,data,errorDatas,loading);
    //                 // resolve(errorDatas);
    //             }).catch(error => {
    //                 // reject(error);
    //             })
    //         }).catch(error => {
    //             // reject(error);
    //         })
    //     }else {
    //         var post = {};
    //         post.importIndustrialSpaceList = data;
    //         importIndustrialSpaces(post).then(response => {
    //             getErrorImportLog({batchNum:response.batchNum}).then(response => {
    //                     for(var t in response.importLogList){
    //                         if(response.importLogList[t].message){
    //                             errorDatas.push(response.importLogList[t]);
    //                         }
    //                     };
    //                     // resolve(errorDatas);
    //                     return errorDatas
    //             }).catch(error => {
    //                 // reject(error);
    //             })
    //         }).catch(error => {
    //             // reject(error);
    //         })
    //     }



    //     // for(var i = 0;i < 2000; i++){
    //     //      if( data.length > len ){
    //     //           postArr.push( new Promise((resolve, reject) => {
    //     //                 var post = {};
    //     //                 post.importIndustrialSpaceList = data.splice(0,len);
    //     //                 setTimeout(function(){
    //     //                       importIndustrialSpaces(post).then(response => {
    //     //                           console.log('importIndustrialSpaces',response);
    //     //                           getErrorImportLog({batchNum:response.payload.batchNum}).then(response => {
    //     //                               console.log('getErrorImportLog',response);
    //     //                                 var errorDatas = [];
    //     //                                 for(var t in response.payload.exportLogs){
    //     //                                      if(response.payload.exportLogs[t].errMsg){
    //     //                                           errorDatas.push(response.payload.exportLogs[t]);
    //     //                                      }
    //     //                                 };
    //     //                                 resolve(errorDatas);
    //     //                           }).catch(error => {
    //     //                                reject(error);
    //     //                           })
    //     //                       }).catch(error => {
    //     //                            reject(error);
    //     //                       })
    //     //                 },i*len );
    //     //           }) );
    //     //      }else {
    //     //          postArr.push( new Promise((resolve, reject) => {
    //     //                var post = {};
    //     //                post.importIndustrialSpaceList = data;
    //     //                importIndustrialSpaces(post).then(response => {
    //     //                    getErrorImportLog({batchNum:response.payload.batchNum}).then(response => {
    //     //                          var errorDatas = [];
    //     //                          for(var t in response.payload.importLogList){
    //     //                               if(response.payload.importLogList[t].errMsg){
    //     //                                    errorDatas.push(response.payload.exportLogs[t]);
    //     //                               }
    //     //                          };
    //     //                          resolve(errorDatas);
    //     //                    }).catch(error => {
    //     //                         reject(error);
    //     //                    })
    //     //                }).catch(error => {
    //     //                     reject(error);
    //     //                })
    //     //          }) );

    //     //          break;
    //     //      }
    //     // }

    //     // Promise.all(postArr).then(result => {

    //     //     var allErrors = [];
    //     //     for(var i = 0;i < result.length;i++){
    //     //         allErrors.push(...result[i]);
    //     //     };

    //     //     var successSure = true;
    //     //     for(var i in allErrors){
    //     //          if(allErrors[i].errMsg){
    //     //               successSure = false;
    //     //               break;
    //     //          }
    //     //     }

    //     //     setTimeout(() => {
    //     //           loading.close();
    //     //           if(successSure){
    //     //                vm.$alert('导入成功！', '提示', {
    //     //                    confirmButtonText: '确定',
    //     //                    type: 'success',
    //     //                    callback: function(action){
    //     //                        vm.$emit('t-frash');
    //     //                    }
    //     //                });
    //     //            }else {
                     
    //     //               vm.$message.error('导入失败！');
    //     //               vm.$emit('excel-errors',allErrors);

    //     //            }
    //     //     }, 600);

    //     // }).catch(error => {
    //     //     loading.close();

    //     //     vm.$emit('t-frash');
     
    //     // })
    // },

    // errorClean:function(){
    //     var dataIN = {};
    //     dataIN.organizationMaterialId = this.orgid;
    //     deleteAll6(dataIN);
    // },

    handleClick(e) {
        console.log(e);
        var vm = this;
        var files = e.target.files;
        var fileReader = new FileReader();

        if (!FileReader.prototype.readAsBinaryString) {
            FileReader.prototype.readAsBinaryString = function (fileData) {
                var data = "";
                var pt = this;
                var reader = new FileReader();
                    reader.onload = function (e) {
                        var bytes = new Uint8Array(reader.result);
                        var length = bytes.byteLength;
                        for (var i = 0; i < length; i++) {
                            data += String.fromCharCode(bytes[i]);
                        }
                        dataRead(data);//解析数据并导入

                        //pt.result  - readonly so assign binary
                    }
                    reader.readAsArrayBuffer(fileData);

            }
        }else {
            fileReader.onload = function(ev){
                var data = ev.target.result;
            
                dataRead(data);//解析数据并导入
                document.getElementById('excel-upload-input').value = '';
            };
            // 以二进制方式打开文件
        }

        fileReader.readAsBinaryString(files[0]);
        function dataRead(data) {
    
            var workbook = XLSX.read(data, {
                    type: 'binary'
                }); // 以二进制流方式读取得到整份excel表格对象
            var persons = []; // 存储获取到的数据
            // 表格的表格范围，可用于判断表头是否数量是否正确
            var fromTo = '';
            // 遍历每张表读取
            for (var sheet in workbook.Sheets) {
                if (workbook.Sheets.hasOwnProperty(sheet)) {
                    fromTo = workbook.Sheets[sheet]['!ref'];
                    var excel=XLSX.utils.sheet_to_json(workbook.Sheets[sheet]);
                    persons = persons.concat(excel);
                    break; // 如果只取第一张表，就取消注释这行
                }
            }
            //   console.log(persons);
            if(persons.length>0){
                    persons.shift();
                    //可以通知外部业务数据进行处理
                    
                    vm.$emit("onSuccess",persons);
                    // var errorDatas = [];
                    // var i=0;
                    // errorDatas = vm.specialUpex(i,persons,errorDatas,loading);
                    // console.log(errorDatas);
                    //     loading.close();

            }else {
                setTimeout(() => {
                    loading.close();
                    vm.$alert('请检查数据后重新导入！', '导入失败', {
                        confirmButtonText: '确定',
                        callback: action => {
                        vm.$message({
                            type: 'error',
                        });
                        }
                    });
                }, 600);

            }

            vm.$emit("imported",persons);

            // console.log(persons);
        };

    },

    readerData(rawFile) {
        const workbook = XLSX.read(btoa(rawFile), { type: 'base64' })
    },

    upLoadFiles:function(){

    }

  },

  created:function(){
       // console.log(this.orgid);
  }
}
</script>

<style>
#excel-upload-input{
    display: none;
    z-index: -9999;
}

.excel-up{
   display: inline-block;
}

.excel-up .el-button{
   margin: 0px !important;
}

</style>



// WEBPACK FOOTER //
// excel.vue?04ad03a9